import React, { useEffect } from "react";
import { object, func, string } from "prop-types";
import { connect } from "react-redux";
import { getCollectionTemplate } from "../../get-collection-template";
import { LazyCollection, LazyLoadImages } from "@quintype/components";

import LoadMoreSectionItems from "./load-more-section-items";
import { QuintTopResponsiveContainer } from "../../rows/ad-free";
import { setSectionId } from "../../helper/actions";
import { addGTMPageVariables } from "../../utils/utils";

/**
 * Section or Sub Section or Collection Page
 *
 * If collections are there then render it else take only stories and render it in a component
 */
const SectionPageBase = ({ data, setSectionId, currentPath }) => {
  const { collection, sectionId, pageNum } = data;

  const collectionStoryObj = { ...collection };
  const collectionObj = { ...collection };

  collectionStoryObj.items = collectionStoryObj.items.filter((item) => item.type === "story").slice(0, 12);

  collectionObj.items = collection.items.filter((item) => item.type === "collection");

  useEffect(() => {
    setSectionId(sectionId);
    addGTMPageVariables(null, "WEB", null, "SECTION");
  }, [sectionId]);

  return (
    <div>
      <QuintTopResponsiveContainer mobile="topAd" desktop="topAd" />
      <LazyLoadImages>
        {collectionObj.items && collectionObj.items.length > 0 ? (
          <LazyCollection collection={collectionObj} collectionTemplates={getCollectionTemplate} lazyAfter={2} />
        ) : (
          <LoadMoreSectionItems collection={collectionStoryObj} pageNum={pageNum} currentPath={currentPath} />
        )}
      </LazyLoadImages>
    </div>
  );
};

SectionPageBase.propTypes = {
  data: object,
  setSectionId: func,
  currentPath: string,
};

const mapDispatchToProps = (dispatch) => ({
  setSectionId: (id) => dispatch(setSectionId(id)),
});

const SectionPage = connect(null, mapDispatchToProps)(SectionPageBase);

export { SectionPage };
